export { default as StaticData } from './StaticData';
export { staticDataAdapter } from './adapters.ts';
